<template>
  <span class="icon-Btn">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="18"
      height="15"
      viewBox="0 0 18 15"
    >
      <defs>
        <path
          id="prefix__a"
          d="M16.664 12.329c.738 0 1.336.598 1.336 1.335 0 .738-.598 1.336-1.336 1.336H1.336C.598 15 0 14.402 0 13.664c0-.737.598-1.335 1.336-1.335h15.328zm0-6.165c.738 0 1.336.598 1.336 1.336 0 .738-.598 1.336-1.336 1.336H1.336C.598 8.836 0 8.238 0 7.5c0-.738.598-1.336 1.336-1.336h15.328zm0-6.164C17.402 0 18 .598 18 1.336c0 .737-.598 1.335-1.336 1.335H1.336C.598 2.671 0 2.073 0 1.336 0 .598.598 0 1.336 0h15.328z"
        />
      </defs>
      <g fill-rule="evenodd">
        <use xlink:href="#prefix__a" />
      </g>
    </svg>
  </span>
</template>
<script>
export default {
  name: "menuIcon",
};
</script>
